<template>
  <div class="zy-div-container login-container">
    <img
      class="img-login"
      src="../assets/image/login-4.jpg"
      alt=""
      galleryimg="no"
      border="0"
    />
    <div class="div-login">
      <div class="div-login-title">{{ webName }}</div>
      <el-input
        class="input"
        v-model="username"
        placeholder="请输入用户名"
        autofocus
        @keyup.enter.native="nextFocus('input1')"
      ></el-input>
      <el-input
        class="input"
        v-model="password"
        show-password
        placeholder="请输入密码"
        ref="input1"
        @keyup.enter.native="nextFocus('input2')"
      ></el-input>
      <el-input
        class="input"
        v-model="googlecode"
        placeholder="请输入谷歌码"
        ref="input2"
        @keyup.enter.native="login"
      >
      </el-input>
      <el-button class="btn" type="primary" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
import API from "./api.js";
import utils from "../lib/utils";
export default {
  name: "Login",
  data() {
    return {
      webName: "集中交易系统",
      username: "",
      password: "",
      googlecode: "",
      smscode: ""
    };
  },
  created() {
    console.log("Utils.getFingerPrint()==", utils.getFingerPrint().toString());
  },
  methods: {
    login() {
      // console.log('------------login--------------')
      if (this.username === "" || this.password === "") {
        this.$notify({
          message: "用户名/密码/不能为空",
          type: "warning"
        });
        return;
      }

      if (this.googlecode === "") {
        this.$notify({
          message: "谷歌码不能为空",
          type: "warning"
        });
        return;
      }

      var data = {
        Uid: this.username,
        Pwd: this.password,
        GoogleCode: this.googlecode,
        MacAddr: utils.getFingerPrint().toString()
      };
      API.doLogin(data)
        .then(res => {
          // console.log('doLogin res===' + JSON.stringify(res))
          if (res.data.errcode) {
            if (res.data.errcode === 3001) {
              this.$notify({
                message: "账号不存在",
                type: "warning"
              });
            } else if (res.data.errcode === 3002) {
              this.$notify({
                message: "密码错误",
                type: "warning"
              });
            } else if (res.data.errcode === 3003) {
              this.$notify({
                message: "谷歌码错误",
                type: "warning"
              });
            } else if (
              res.data.errcode === 3009 ||
              res.data.errcode === 3010 ||
              res.data.errcode === 3011
            ) {
              this.askForSmsCode(this.username);
              this.$prompt("请输入短信验证码激活本机", "", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputErrorMessage: "短信验证码格式不正确"
              })
                .then(({ value }) => {
                  // 验证短信码
                  this.validSmsCode(this.username, value);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "取消输入"
                  });
                });
            }
          } else {
            // 登录成功
            console.log('doLogin res.data==', res.data)
            utils.setCookie("tamc_token", res.data.token);
            localStorage.setItem("userName", this.username);
            localStorage.setItem("userRole", "admin");
            // 保存用户角色信息
            if (res.data.role) {
              localStorage.setItem("userRole", res.data.role); 
            }
            // 登录成功
            this.$router.push("/home");
          }
        })
        .catch(err => {
          console.log("doLogin err", err);
        });
    },
    /**
     * 请求验证码
     */
    askForSmsCode(uid) {
      var data = {
        Uid: uid
      };
      API.askForSmsCode(data)
        .then(res => {
          if (res.data.errcode === 3006) {
            this.$notify({
              message: "短信请求太频繁",
              type: "warning"
            });
          } else if (res.data.errcode === 3008) {
            this.$notify({
              message: "获取短信验证码失败",
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log("askForSmsCode err", err);
        });
    },
    /**
     * 验证短信
     */
    validSmsCode(uid, smscode) {
      var data = {
        Uid: uid,
        Smscode: smscode
      };
      API.validSmsCode(data)
        .then(res => {
          console.log('validSmscode res==', res)
          if (res.data.errcode) {
            if (res.data.errcode === 3004) {
              this.$notify({
                message: "短信验证码错误",
                type: "warning"
              });
            }
          } else {
            // 验证短信成功
            utils.setCookie("tamc_token", res.data.token);
            localStorage.setItem("userName", this.username);
            if (res.data.role) {
              localStorage.setItem("userRole", res.data.role); 
            }
            this.$router.push("/home");
          }
        })
        .catch(err => {
          console.log("validSmsCode err", err);
        });
    },
    nextFocus(nextRef) {
      this.$nextTick(function() {
        this.$refs[nextRef].focus();
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  width: 220px;
  /* height: 30px; */
  border: 0px;
  margin-top: 10px;
  color: #ffffff;
  background-color: #00b7d3;
}
.input {
  margin-bottom: 15px;
}

.img-login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.div-login {
  position: relative;
  width: 290px;
  margin: 10% auto;
  padding: 29px 40px 40px;
  background-color: #ffffff;
}
.div-login-title {
  color: rgb(14, 12, 12);
  height: 60px;
  text-align: center;
  font-size: 26px;
  font-weight: 500;
  font-family: "SimHei";
}

.title {
  font-size: 20px;
  font-weight: bold;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
